module.exports = __webpack_public_path__ + "static/img/advance04.b05cd8ed.png";